<template>
  <div>
    <report-base
      title="Sales Report"
      table-class="analytics-tables--sales"
      subject="sales"
      :items="sales"
      :fields="fields"
      :is-loading="loading"
      @reload="loadData"
    />
  </div>
</template>

<script>
import AnalyticsMixin from './mixin';

export default {
  name: 'analytics-sales',

  mixins: [
    AnalyticsMixin
  ],

  data() {
    return {
      sales: [],
      filter: '',
      fields: [
        {
          key: 'customer',
          label: 'Customer',
          sortable: true,
        },
        {
          key: 'customer_type',
          label: 'Customer Type',
          sortable: true,
        },
        {
          key: 'date',
          label: 'Date',
          sortable: true,
        },
        {
          key: 'sub_total',
          label: 'Sub Total',
          sortable: true,
        },
        {
          key: 'discounts',
          label: 'Discounts',
          sortable: true,
        },
        {
          key: 'refunded',
          label: 'Refunds',
          sortable: true,
        },
        {
          key: 'taxes_total',
          label: 'Taxes & Fees',
          sortable: true,
        },
        {
          key: 'gratuity',
          label: 'Tips',
          sortable: true,
        },
        {
          key: 'grand_total',
          label: 'Total',
          sortable: true,
        },
        {
          key: 'payments_made',
          label: 'Payments',
          sortable: true,
        },
        {
          key: 'balance_due',
          label: 'Banance',
          sortable: true,
        },
      ]
    };
  },

  mounted() {
    this.loadData();
  },

  methods: {
    loadData () {
      this.loading = true;

      this.fetchData('sales')
        .then(res => {
          this.sales = res.data
            .map(sale => {
              sale.date = this.formatDate(sale.date),
              sale.sub_total = this.formatMoney(sale.sub_total);
              sale.taxes_total = this.formatMoney(sale.taxes_total);
              sale.refunded = this.formatMoney(sale.refunded);
              sale.discounts = this.formatMoney(sale.discounts);
              sale.gratuity = this.formatMoney(sale.gratuity);
              sale.grand_total = this.formatMoney(sale.grand_total);
              sale.balance_due = this.formatMoney(sale.balance_due);
              sale.payments_made = this.formatMoney(sale.payments_made);

              return sale;
            })
        })
        .catch(err => {
          this.errorNotification('Failed to fetch booking report!');
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
  .analytics-tables--sales {
    table {
      min-width: 1500px !important;
      position: relative;
    }
  }
</style>
